// apps/web/src/data/vocab/types.ts
//
// Mirrors apps/a2-easy-web/lib/domain/vocab/types.ts. The vocab library is
// pure curated data — kept as types here (without zod parsing in the
// browser bundle) since vocab.json is treated as trusted.

export type Pos = "noun" | "verb" | "adjective" | "phrase" | "other" | "unknown";

export const TOPIC_KEYS = [
  "super-zinnen",
  "magic-words",
  "numbers-time",
  "familie-mensen",
  "lichaam-gezondheid",
  "eten-drinken",
  "kleding",
  "huis-kamers",
  "boodschappen",
  "werk-beroepen",
  "onderwijs",
  "vrije-tijd-sport",
  "vervoer",
  "geld-bank",
  "digitaal",
  "duurzaamheid",
  "weer-natuur",
  "adjectives-comparatives",
  "vraagwoorden",
  "irregular-past-tense",
  "templates-by-deel",
] as const;

export type TopicKey = (typeof TOPIC_KEYS)[number];

const TOPIC_KEY_SET: ReadonlySet<string> = new Set(TOPIC_KEYS);

export function isTopicKey(value: string): value is TopicKey {
  return TOPIC_KEY_SET.has(value);
}

export type VocabEntry = {
  id: string;
  dutch: string;
  english: string;
  pos: Pos;
  topic: TopicKey;
  gender?: "de" | "het";
  plural?: string;
  pastTense?: string;
  comparative?: string;
  prepositions?: string[];
  examples: string[];
  usageTip?: string;
};

export type VocabStats = {
  total: number;
  byTopic: Record<TopicKey, number>;
  byPos: Record<Pos, number>;
  enrichedCount: number;
  plainCount: number;
};

export type VocabLibrary = {
  version: string;
  generatedAt: string;
  stats: VocabStats;
  entries: VocabEntry[];
};

export const ALL_TOPIC_KEYS: readonly TopicKey[] = TOPIC_KEYS;
